export default __webpack_public_path__ + "static/media/sd-email-header.a2df59a7.png";